// Deleted:import 'react-app-polyfill/ie11';
// Deleted:import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './customAntd.scss'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AppContextProvider, colorPrimary } from '@utils/AppContext';
import { ConfigProvider, Spin } from 'antd';
// import "./i18n/config";
import PSAISpinDot from './PSAIComponents/PSAISpinDot';
import './upload-polyfill'
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
// import advancedFormat from 'dayjs/plugin/advancedFormat'
// import customParseFormat from 'dayjs/plugin/customParseFormat'
// import localeData from 'dayjs/plugin/localeData'
// import weekday from 'dayjs/plugin/weekday'
// import weekOfYear from 'dayjs/plugin/weekOfYear'
// import weekYear from 'dayjs/plugin/weekYear'
// import utc from "dayjs/plugin/utc"
import 'dayjs/locale/zh-cn';

// dayjs.extend(utc)
// dayjs.extend(customParseFormat)
// dayjs.extend(advancedFormat)
// dayjs.extend(weekday)
// dayjs.extend(localeData)
// dayjs.extend(weekOfYear)
// dayjs.extend(weekYear)
dayjs.locale('zh-cn');

// 移动端&PC端适配，相互跳转
// if (Utils.isMobileDevice()) {
//     if (!/^\/mobile/.test(location.pathname) && !/^\/activity/.test(location.pathname)) {
//         window.location.replace('/mobile/' + location.search)
//     }
// } else {
   
// }
if (/^\/mobile/.test(location.pathname)) {
    window.location.replace('/' + location.search)
}

Spin.setDefaultIndicator(<PSAISpinDot />)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ConfigProvider locale={zhCN} theme={{ token: { colorPrimary } }}>
            <AppContextProvider>
                <DndProvider backend={HTML5Backend}>
                    <App />
                </DndProvider>
            </AppContextProvider>
        </ConfigProvider>
    </BrowserRouter>
);

reportWebVitals((res) => {
});


